<template>
  <Card :pt="simpleCardPassthrough">
    <template #title>{{ title }}</template>
    <template #subtitle>{{ subtitle }}</template>
    <template #footer>
      <button
        @click="$emit('edit')"
        :aria-label="`${title} ${$t('dbc-button-edit')}`"
        class="flex justify-center items-center w-[48px] h-[48px] border-solid border rounded-full border-cool-gray-200 active:border-cool-gray-300 bg-white active:bg-cool-gray-300 cursor-pointer text-dark active:text-cool-gray-500"
      >
        <DbcSvg name="dbc-icon-edit" />
      </button>
    </template>
  </Card>
</template>

<script setup lang="ts">
import Card from 'primevue/card'

defineProps<{
  title: string
  subtitle: string
}>()

defineEmits<{
  (e: 'edit'): void
}>()
</script>
